import store from "../store";
import CandidateLayout from './../views/dashboard/CandidateLayout.vue'
import Candindex from './../views/dashboard/Candindex.vue'
import CollegeLayout from './../views/dashboard/CollegeLayout.vue'
import Collegeindex from './../views/dashboard/Collegeindex.vue'
import TeacherIndex from "../views/dashboard/TeacherIndex";
function lazyLoad(view){
    return() => import(`@/views/dashboard/${view}.vue`)
}
export function dashboardType(){
    if(store.getters.getUserType) {
        if (store.getters.getUserType === "Individual") {
            return {
                path: '/dashboard',
                name: 'dashboard',
                component: CandidateLayout,
                children: [
                    {
                        path: '',
                        name: 'candidate_index',
                        component: Candindex,
                    },
                    {
                        path: 'edit',
                        name: 'candidate_edit',
                        component: lazyLoad('Candedit'),
                    },
                    {
                        path: 'resume',
                        name: 'candidate_resume',
                        component: lazyLoad('CandResume'),
                    },
                    {
                        path: 'applied',
                        name: 'candidate_applied',
                        component: lazyLoad('CandApplied'),
                    },
                    {
                        path: 'applied-internships',
                        name: 'candidate_applied_internships',
                        component: lazyLoad('CandAppliedInternships'),
                    },
                    {
                        path: 'scheduled-classes',
                        name: 'scheduled_classes',
                        component: lazyLoad('CandScheduledClasses'),
                    },
                    {
                        path:'stream',
                        name:'streamCass',
                        component: lazyLoad('StreamClass')
                    },
                    {
                        path:'previous-notes',
                        name:'previousNotes',
                        component: lazyLoad('PreviousNotes')
                    },
                    {
                        path:'webinars',
                        name:'webinars',
                        component: lazyLoad('Webinars')
                    },
                    {
                        path:'webinar-detail',
                        name:'webinar-detail',
                        component: lazyLoad('WebinarDetail')
                    },
                    {
                        path:'stream-webinar',
                        name:'stream-webinar',
                        component: lazyLoad('StreamWebinar')
                    },
                    {
                        path:'jobs',
                        name:'alljobs',
                        component:lazyLoad('AllJobs')
                    },
                    {
                        path:'internships',
                        name:'allinternships',
                        component:lazyLoad('AllInternships')
                    },
                    {
                        path:'education-loan',
                        name:'EducationLoanForm',
                        component:lazyLoad('EducationLoanForm')
                    },
                    {
                        path:'fill-questionnaire',
                        name:'QuestionnaireForm',
                        component:lazyLoad('QuestionnaireForm')
                    },
                    {
                        path: 'quiz-view',
                        name: 'quiz-view',
                        component: lazyLoad('QuizView')
                    },
                    {
                        path: 'quiz',
                        name: 'quiz',
                        component: lazyLoad('Quiz')
                    },
                    {
                        path: '/play/:id',
                        name: 'play-quiz',
                        component: lazyLoad('PlayQuiz')
                    },
                    {
                        path: 'webinar-view',
                        name: 'webinar-view',
                        component: lazyLoad('WebinarView')
                    },
                    {
                        path: 'webinar-speakers',
                        name: 'webinar-speakers',
                        component: lazyLoad('WebinarSpeakers')
                    },
                    {
                        path: 'applied-loan',
                        name: 'applied-loan',
                        component: lazyLoad('AppliedLoanStatus')
                    },
                    {
                        path: 'loan-application-detail',
                        name: 'LoanApplicationDetail',
                        component: lazyLoad('LoanApplicationDetail')
                    },
                    {
                        path: 'shortlisted-applications',
                        name: 'ShortlistedApplications',
                        component: lazyLoad('ShortlistedApplication')
                    },
                    {
                        path: 'skill-up',
                        name: 'skill-up',
                        component: lazyLoad('SkillUp')
                    },
                    {
                        path: 'skill-up-detail',
                        name: 'skill-up-detail',
                        component: lazyLoad('SkillUpDetail')
                    },
                ]
            }
        } else if(store.getters.getUserType === "teacher") {
            return {
                path: '/dashboard',
                name: 'dashboard',
                component:CollegeLayout,
                children:[
                    {
                        path:'',
                        name:'teacherindex',
                        component: TeacherIndex
                    },
                    {
                        path:'edit',
                        name:'teacheredit',
                        component: lazyLoad('TeacherEdit')
                    },
                    {
                        path:'broadcast',
                        name:'classBroadcast',
                        component: lazyLoad('BroadCastClass')
                    },
                    {
                        path:'create-quiz-bank',
                        name:'CreateQuizBank',
                        component: lazyLoad('CreateQuizBank')
                    },
                    {
                        path:'quiz',
                        name:'quiz',
                        component: lazyLoad('SchoolQuiz')
                    },
                    {
                        path:'quiz-stats',
                        name:'quizstats',
                        component: lazyLoad('QuizStats')
                    },
                    {
                        path:'create-quiz',
                        name: 'createQuiz',
                        component: lazyLoad('QuizCreate')
                    },
                    {
                        path: 'quiz-detail',
                        name: 'quiz-detail',
                        component: lazyLoad('QuizDetail')
                    },
                    {
                        path: 'skill-up',
                        name: 'skill-up',
                        component: lazyLoad('SkillUp')
                    },
                    {
                        path: 'skill-up-detail',
                        name: 'skill-up-detail',
                        component: lazyLoad('SkillUpDetail')
                    },
                    {
                        path: 'my-desk',
                        name: 'my-desk',
                        component: lazyLoad('MyDesk')
                    },
                ]
            }
        } else {
            return {
                path: '/dashboard',
                name: 'dashboard',
                component:CollegeLayout,
                children:[
                    {
                        path:'',
                        name:'collegeindex',
                        component: Collegeindex
                    },
                    {
                        path:'edit',
                        name:'collegeedit',
                        // component: lazyLoad('CollegeEdit')
                        component: lazyLoad('CollegeProfileEdit')
                    },
                    {
                        path:'jobs',
                        name:'CollegeJobs',
                        component:lazyLoad('CollegeJobs')
                    },
                    {
                        path:'internships',
                        name:'CollegeInternships',
                        component:lazyLoad('CollegeInternships')
                    },
                    {
                        path:'viewcandidates',
                        name:'collegecandidate',
                        component:lazyLoad('CollegeCandidates')
                    },
                    {
                        path: 'viewcompanies',
                        name: 'collegeviewcompanies',
                        component: lazyLoad('CollegeViewCompanies')
                    },
                    {
                        path:'manage-candidates',
                        name: 'managecandidates',
                        component: lazyLoad('ManageCandidates')
                    },
                    {
                        path:'manage-loan-applicants',
                        name: 'manageLoanApplicants',
                        component: lazyLoad('ManageLoanApplicants')
                    },
                    {
                        path:'all-jobs',
                        name:'alljobs',
                        component:lazyLoad('AllJobs')
                    },
                    {
                        path:'all-internships',
                        name:'allinternships',
                        component:lazyLoad('AllInternships')
                    },
                    {
                        path:'view-requested',
                        name:'viewrequestedapplications',
                        component:lazyLoad('ViewRequestedApplications')
                    },
                    {
                        path:'application-processes',
                        name:'applicationProcesses',
                        component:lazyLoad('ApplicationProcesses')
                    },
                    {
                        path:'preferences',
                        name:'preferences',
                        component: lazyLoad('CollegePreferences')
                    },
                    {
                        path:'loan-applicants',
                        name:'loanApplicants',
                        component:lazyLoad('LoanApplicants')
                    },
                    {
                        path:'webinars',
                        name:'webinars',
                        component: lazyLoad('Webinars')
                    },
                    {
                        path:'webinar-detail',
                        name:'webinar-detail',
                        component: lazyLoad('WebinarDetail')
                    },
                    {
                        path: 'webinar-view',
                        name: 'webinar-view',
                        component: lazyLoad('WebinarView')
                    },
                    {
                        path: 'webinar-speakers',
                        name: 'webinar-speakers',
                        component: lazyLoad('WebinarSpeakers')
                    },
                    // {
                    //     path: 'college-profile-edit',
                    //     name: 'college-profile-edit',
                    //     component: lazyLoad('CollegeProfileEdit')
                    // },
                    {
                        path: 'skill-up',
                        name: 'skill-up',
                        component: lazyLoad('SkillUp')
                    },
                    {
                        path: 'skill-up-detail',
                        name: 'skill-up-detail',
                        component: lazyLoad('SkillUpDetail')
                    },
                    {
                        path: 'admissions-list',
                        name: 'admissions-list',
                        component: lazyLoad('AdmissionsList')
                    },
                ]
            }
        }
    }else{
        return {
            path: '*',
            redirect: '/'
        }
    }
}

export function blankDashboardType(){
    if(store.getters.getUserType) {
        // if (store.getters.getUserType === "Individual") {
            return {
                path: '/dashboard/play/:id',
                name: 'play-quiz',
                component: lazyLoad('PlayQuiz')
            }
        // }
    }else{
        return {
            path: '*',
            redirect: '/'
        }
    }
}